export default "__VITE_ASSET__nKJHKKWC__"